import styled from 'styled-components';
import Flex from './Flex';

const DialogContainer = styled(Flex)`
    background: ${props => props.theme.primaryBackgroundColor };
    margin: 25px 25px;
    border-radius: 5px;
    height: 75%;
    padding: 10px;
    display: flex;
    flex-direction: ${props => props.row ? 'row' : 'column'};
    justify-content: ${props => props.justifyContent || 'space-between'};
    align-items: ${props => props.alignItems || 'center'};
`;

export default DialogContainer;


// WEBPACK FOOTER //
// ./src/components/DialogContainer.js